import type { Dispatch, SetStateAction } from "react";
import { setNotaryContactEmailPromptDismissedInSession } from "./notaryMissingContactEmailSession";

export { NOTARY_CONTACT_EMAIL_PROMPT_DISMISS_STORAGE_KEY } from "./notaryMissingContactEmailSession";

export function dismissNotaryContactEmailModalForSession(setOpen: Dispatch<SetStateAction<boolean>>): void {
	setNotaryContactEmailPromptDismissedInSession();
	setOpen(false);
}
